(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Ganache", [], factory);
	else if(typeof exports === 'object')
		exports["Ganache"] = factory();
	else
		root["Ganache"] = factory();
})(global, function() {
return 